import { render, staticRenderFns } from "./TrasladoParto.vue?vue&type=template&id=3872170d&scoped=true"
import script from "./TrasladoParto.vue?vue&type=script&lang=js"
export * from "./TrasladoParto.vue?vue&type=script&lang=js"
import style0 from "./TrasladoParto.vue?vue&type=style&index=0&id=3872170d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3872170d",
  null
  
)

export default component.exports